import Clients from '../pages/Clients';
import PromoCodes from '../pages/PromoCodes';
import Configurations from '../pages/Configurations';
import Drivers from '../pages/Drivers';
import Products from '../pages/Products';
import Support from '../pages/Support';
import VentesStocks from '../pages/VentesStocks';
import PushNotification from '../pages/PushNotification';
import Categories from '../pages/Categories';
import Invoice from '../pages/Invoice';
import {
  GeneralConfig,
  HubriseConfig,
  PrinterConfig,
  DeliveryZone,
  SpecialHoursConfig,
  HoursConfig,
  PaymentAndOrderTypesConfig,
  DeliverySettings,
  OrderSettings,
  WebDesign,
  MobileDesign,
  LoyaltyProgram,
  Activation,
  ManagementFee,
  DeepLink,
  CampaignPromo,
  marketingCampaigns,
  ContactSupport

} from '../components';
import Design from '../pages/Design';
import {
  HUBRISE_ROUTE,
  GENERAL_CONFIG_ROUTE,
  SALES_TYPE_ROUTE,
  PAYMENTS_ROUTE,
  PRINTER_ROUTE,
  DELIVERY_ZONE_ROUTE,
  OPENED_HOUR_ROUTE,
  DELIVERY_HOUR_ROUTE,
  SPECIFIC_HOUR_ROUTE,
  DELIVERY_SETTINGS_ROUTE,
  ORDER_SETTINGS_ROUTE,
  GENERAL_DESIGN_ROUTE,
  WEB_DESIGN_ROUTE,
  MOBILE_DESIGN_ROUTE,
  PUSH_NOTIF_ROUTE,
  CODE_PROMO_ROUTE,
  FEDILITY_PROGRAM_ROUTE,
  ACTIVATION_ROUTE,
  MANAGEMENT_FEE_ROUTE,
  DEEPLINK_ROUTE,
  CAMPAIGN_PROMO_ROUTE,
  CAMPAIGNS_ROUTE,
 CONTACT_SUPPORT_ROUTE
} from './routes';
import Marketing from '../pages/Marketing';
import Finances from '../pages/Finances';
import Assitance from '../pages/Assistance';

export default [
  { path: GENERAL_CONFIG_ROUTE, component: GeneralConfig, exact: true },
  { path: DELIVERY_ZONE_ROUTE, component: DeliveryZone, exact: true },
  { path: OPENED_HOUR_ROUTE, component: HoursConfig, exact: true },
  { path: DELIVERY_HOUR_ROUTE, component: HoursConfig, exact: true },
  { path: SPECIFIC_HOUR_ROUTE, component: SpecialHoursConfig, exact: true },
  { path: PAYMENTS_ROUTE, component: PaymentAndOrderTypesConfig, exact: true },
  { path: SALES_TYPE_ROUTE, component: PaymentAndOrderTypesConfig, exact: true },
  { path: PRINTER_ROUTE, component: PrinterConfig, exact: true },
  { path: DELIVERY_SETTINGS_ROUTE, component: DeliverySettings, exact: true },
  { path: ORDER_SETTINGS_ROUTE, component: OrderSettings, exact: true },
  { path: GENERAL_DESIGN_ROUTE, component: Design, exact: true },
  { path: HUBRISE_ROUTE, component: HubriseConfig, exact: true },
  { path: WEB_DESIGN_ROUTE, component: WebDesign, exact: true },
  { path: MOBILE_DESIGN_ROUTE, component: MobileDesign, exact: true },
  { path: FEDILITY_PROGRAM_ROUTE, component: LoyaltyProgram, exact: true },
  { path: ACTIVATION_ROUTE, component: Activation, exact: true },
  { path: MANAGEMENT_FEE_ROUTE, component: ManagementFee, exact: true },
  { path: DEEPLINK_ROUTE, component: DeepLink, exact: true },
  { path: CAMPAIGN_PROMO_ROUTE, component: CampaignPromo, exact: true },
  { path: CAMPAIGNS_ROUTE, component: marketingCampaigns, exact: true },
  { path: CONTACT_SUPPORT_ROUTE, component: ContactSupport, exact: true },
  { title: 'Réglages', path: '/settings', component: Configurations },
  { title: 'Clients', path: '/clients', component: Clients },
  { title: 'Codes Promotionnels', path: CODE_PROMO_ROUTE, component: PromoCodes },
  { title: 'Livreurs', path: '/livreurs', component: Drivers },
  { title: 'Produits', path: '/products', component: Products },
  { title: "Liste d'options", path: '/options-products', component: Categories },
  { title: 'Support', path: '/support', component: Support },
  { title: 'Push Notifications', path: PUSH_NOTIF_ROUTE, component: PushNotification },
  { title: 'Ventes / Stocks', path: '/sales', component: VentesStocks },
  { title: 'Factures', path: '/invoice', component: Invoice },
  { title: 'Marketing', path: '/marketing', component: Marketing },
  { title: 'Finances', path: '/finances', component: Finances },
  { title: `Besoin d'aide`, path: '/help', component: Assitance },

];
